<template>
  <nav01 style="background: #161b1f;" title="详情"></nav01>
  <div class="newsdetails-box">
    <div class="newsdetails-content">
      <h3>{{ state.title }}</h3>
      <p>发布时间：{{ state.time }}</p>
      <!-- <div>{{state.content}}</div> -->
      <div v-html="state.content"></div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";
import { useRouter, useRoute } from "vue-router";
import { newsdetail } from "@/api/yzgame";
import { getQueryString } from "@/utils/location";
import { groupNewsdetail } from "@/api/chat";

export default {
  name: "newsdetails",
  setup() {
    const router = useRouter();
    const route = useRoute();

    const state = reactive({
      // title: '活动标题', // time: '2021-03-07', // content: '活动内容'
    });

    console.log(getQueryString("id"));
    groupNewsdetail({
      id: getQueryString("id"),
    }).then((response) => {
      // console.log("详情------------------------", response);
      // state.title = response.data.post_title
      state.time = response.data.post_date;
      state.content = response.data.post_content;
    });

    // 返回
    const onClickLeft = () => {
      router.back();
    };
    return {
      state,
      onClickLeft,
    };
  },
};
</script>

<style scoped="scoped">
.newsdetails-content {
  padding: 30px;
  min-height: 100vh;
  background-color: #161b1f;
  padding-top: calc(112px + constant(safe-area-inset-top));
  padding-top: calc(112px + env(safe-area-inset-top));
}
.newsdetails-content h3 {
  font-size: 36px;
  color: #fff;
  text-align: center;
  margin-bottom: 30px;
}

:deep(.newsdetails-content p) {
  font-size: 26px;
  color: #fff;
  text-align: center;
  margin-bottom: 30px;
}
</style>
